import {
  BlockedContact,
  BlockedContactData,
  BlockedContactRepository,
  DatabaseService,
} from "@/core";
import { DatabaseCollection } from "./config";
import { getGenericRepository } from "./generic-repository";

export function getBlockedContactRepository(
  databaseService: DatabaseService,
): BlockedContactRepository {
  return getGenericRepository<BlockedContact, BlockedContactData>(
    () => DatabaseCollection.BLOCKED_CONTACTS,
    databaseService,
  );
}
